import Vue from "vue";

import TopupWithPrices from './Components/topupWithPrices';
import AmountsWithTransferSummary from './Components/amountsWithTransferSummary';
import HtmlElementHelper from "../../../../Shared/Helpers/htmlElementHelper";

export class TopicHelper {
    public static updateTopics(id: string, storeId: string) {
        let verificationToken = document.getElementsByName("__RequestVerificationToken")[0] as HTMLInputElement;

        const formData = new URLSearchParams();
        formData.append('url', location.origin + location.pathname);
        formData.append('id', id);
        formData.append('storeId', storeId);
        formData.append('__RequestVerificationToken', verificationToken.value);

        fetch("/fmtopics/updatehtml", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: formData
        }).then(response => {
            HtmlElementHelper.Hide('#successMessage');
            HtmlElementHelper.Hide('#errorMessage');
            HtmlElementHelper.Show(response.ok ? '#successMessage' : '#errorMessage');
        });
    }
}

(<any>window).TopicHelper = TopicHelper;


export const fmComponentsContainer = new Vue({
    data: {
        Urls: {
            FetchTranslationsUrl: "/vue/components/translations/fetch"
        }
    },
    components: {
        "AmountsWithTransferSummary": AmountsWithTransferSummary,
        "TopupWithPrices": TopupWithPrices
    }
});

if (document.getElementById("vue-components-container")) {
    fmComponentsContainer.$mount('#vue-components-container');
}



/* #endregion mobile main menu */